/** One line on an account-level or party-level trust ledger, as the backend returns it. */
export interface ITrustAccountLedgerRow {
  id: number
  /** `loan` for a row read out of a loan's trust ledger, `entry` for account-level cash. */
  source: 'loan' | 'entry'
  trustAccountId: number
  trustAccountName: string
  /** 0 when the row is party-level cash with no loan behind it. */
  loanNumber: number
  categoryKey: string
  category: string
  type: string
  date: string
  reference: string
  fromWhom: string
  memo: string
  payment: number
  deposit: number
  fees: number
  balance: number
  partyType?: string
  partyId?: number
  transferGroup?: string
}

export interface ITrustAccountLedgerResponse {
  totalCount: number
  results: ITrustAccountLedgerRow[]
  totals: Array<{ trustAccountId: number; name: string; balance: number }>
  balance: number
  party?: { type: string; id: number; name: string } | null
  accounts?: Array<{ id: number; name: string; purposes: string[] }>
}

export interface ITrustAccount {
  id: number
  name: string
  bankName: string
  accountHolder: string
  routingNo: string
  accountNo: string
  accountNoMasked?: string
  glAccountNo: string
  purposes: string[]
  ownerType: string
  ownerId: number
  isDefault: boolean
  isActive: boolean
  openingBalance: number
  openingBalanceDate: string
  note: string
}

export const TRUST_ACCOUNT_PURPOSES: Record<string, string> = {
  origination: 'Origination',
  construction: 'Construction',
  servicing: 'Servicing',
}

export const TRUST_ACCOUNT_OWNER_TYPES: Record<string, string> = {
  Company: 'Company',
  Lender: 'Lender',
  Vendor: 'Vendor',
}
